import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, Modal } from "semantic-ui-react";
import { selectTranslations } from "../../../config/i18n/slice";
import DataTable from "react-data-table-component";
import { ArrowLeft, ArrowRight, CloseIcon } from "../../../../Assets/Icons/svg";
import Pagination from "../../common/Pagination";

function PartsBulkUploadResult({
  isOpen = false,
  setModalOpenState = () => {},
partData = {},
  setPartUploadModal
}) {
  const t = useSelector(selectTranslations);
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const errorsAndAlerts = partData?.data

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#E9F2FF",
        paddingTop: "8px",
      },
    },
  };

  const getPaginatedData = (dataToPaginate) => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return dataToPaginate.slice(startIndex, endIndex);
  };
  /**
   * Table Fields
   */
  const columns = [
    {
      name: t.parts.part_data_name,
      selector: (row) => row.name,
      sortable: true,
      minWidth: "400px",
      cell: (row) => <span className="id-text-style">{row?.name}</span>,
    },
    {
      name: t.categories.status,
      selector: (row) => row.status,
      sortable: true,
      cell: (row) =>
        row?.importStatus && row.importStatus == "failed" ? (
          <span className="text-dark-red">{t.categories.failed}</span>
        ) : (
          <span className="text-dark-green">{t.categories.success}</span>
        ),
    },
    {
      name: t.assets.message,
      selector: (row) => row?.error,
      sortable: true,
      minWidth: "400px",
      cell: (row) =>
        row?.importStatus && row.importStatus == "failed" ? (
          row?.error?.length > 0 && Array.isArray(row.error) ? (
            <div className="error-list ml-3 mr-3">
             <ul className="mb-0 mt-0 pl-5">
                {row.error.map((err, index) => (
                  <li key={index} className="id-text-style mt-1 mb-1">
                    <span> {err}</span>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
             "-"
          )
        ) : (
           "-"
        ),
    },
  ];
  return (
    <Modal
      size="large"
      open={isOpen}
      onClose={() => setModalOpenState(false)}
     className="assets-modal category-modal"
    >
      <div className="header-container">
        <span className="assets-header">
          {" "}
          {t.assets.part_bulk_upload_title}
        </span>
        <div>
          <span
            className="c-pointer text-right"
            onClick={() => setModalOpenState(false)}
          >
            <CloseIcon />
          </span>
        </div>
      </div>
      <Modal.Content className="scroll-data">
        <div className="mb-7">
          <span className="new-grey-btn ml-0 mr-0">
            {t.assets.imported_part} &nbsp; &nbsp; &nbsp;
            {partData?.importedParts ? partData?.importedParts : 0}{" "}
          </span>

          <span className="new-grey-btn green ml-7 mr-7">
           {t.categories.table.validRows} &nbsp; &nbsp; &nbsp;
            {partData?.successParts ? partData?.successParts : 0}{" "}
          </span>
          <span className="new-grey-btn red ml-0 mr-0">
            {t.categories.table.inValidRows} &nbsp; &nbsp; &nbsp;
            {partData?.failedParts
 ? partData?.failedParts
 : 0}{" "}
          </span>
        </div>
        <div className="bulk-upload-table">
          <DataTable
            customStyles={customStyles}
            columns={columns}
            
            data={getPaginatedData(errorsAndAlerts || [])}
           
            noDataComponent={t.common.no_result_found}
            direction={selectedLanguage === "en" ? "ltr" : "rtl"}
          />
        </div>
        <div className="d-flex justify-content-end">
          <Pagination
            ofString={t.common.of}
            total={errorsAndAlerts?.length || 0}
            prevItem={
              selectedLanguage === "en" ? <ArrowLeft /> : <ArrowRight />
            }
            nextItem={
              selectedLanguage === "en" ? <ArrowRight /> : <ArrowLeft />
            }
            page={currentPage}
            limit={pageSize}
            handleNext={() => {
              setCurrentPage(currentPage + 1);
            }}
            handlePrevious={() => {
              setCurrentPage(currentPage - 1);
            }}
            parts={true}
          />
        </div>
      </Modal.Content>
       <div
          className={`modal-button-container justify-content-center mt-4 ${
            selectedLanguage == "en" ? "mr-8" : "ml-10"
          }`}
        >
          <button
            onClick={() => {
              setPartUploadModal(true);
              setModalOpenState(false);
            }}
            className="modal-form-action-button light-blue"
          >
            {t.categories.table.reuploadFile}
          </button>
        </div>
    </Modal>
  );
}

export default PartsBulkUploadResult;
